import { FC } from 'react'

import { Card, CardContent, Grid, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'

import { ShipmentDetailTitleSkeleton } from '../details/detailsSkeleton'

const ShipmentContainersMainSkeleton: FC = () => {
  return (
    <Stack gap={24}>
      <Card>
        <CardContent>
          <Stack gap={16}>
            <Grid col={4}>
              <Skeleton variant="badge" fullWidth />
            </Grid>
            <Grid col={5} gap={24}>
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
              <Skeleton variant="button" fullWidth />
            </Grid>
          </Stack>
        </CardContent>
      </Card>
      <Table
        columns={Array.from({ length: 5 }).map((_, index) => ({
          id: `$${index}`,
          header: () => <Skeleton variant="content" />,
          cell: () => <Skeleton variant="content" />,
          accessorKey: '',
        }))}
        data={[{}]}
        footless
      />
    </Stack>
  )
}

export const ShipmentContainersSkeleton: FC = () => {
  return (
    <Layout
      header={<Header />}
      title={<ShipmentDetailTitleSkeleton />}
      hideTitleBackgroundImage
      sidebar={<WidgetSkeleton count={1} />}
      navigation={<Back to="/" />}
      main={<ShipmentContainersMainSkeleton />}
      footer={<Footer />}
    />
  )
}
